import axios from "axios";

const upload = (file:any, onUploadProgress:any) => {
  let formData = new FormData();
  formData.append("file", file);
  return axios.post(`/maintenance/backup/restore`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

const FileUploadService = {
  upload,
};

export default FileUploadService;